import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { useModuleApi } from '../ortak/moduleApi';
import { EnflasyonTab, BankaFaturaTab, YsFaturaTab, SozlesmelerTab, DefterTab } from './tabs';
import '../ortak/nfmodules.css';

const { Title } = Typography;

// 27.10 düzeltmesi: derin bağlantı — ?tab=<sekme anahtarı> açılışta o sekmeyi açar (geçersizse
// ilk sekme); ?lokasyon=<MaptriksID> Yer Sahibi Fatura listelerini o lokasyona süzer
// (lokasyon detayındaki YsOdemeleriPanel 'Sözleşme Fatura İşlemleri' butonu).
export default function SozlesmeFaturaPage() {
  const api = useModuleApi('/contracts');
  const [searchParams, setSearchParams] = useSearchParams();
  const lokasyon = (searchParams.get('lokasyon') || '').trim() || undefined;
  // Etiket kapatılınca URL'den de düşülür (yenileyince süzgeç geri gelmesin)
  const lokasyonKaldir = () => setSearchParams((p) => {
    const yeni = new URLSearchParams(p);
    yeni.delete('lokasyon');
    return yeni;
  }, { replace: true });
  const items = [
    { key: 'banka-fatura', label: 'Banka Fatura', children: <BankaFaturaTab api={api} /> },
    {
      key: 'ys-fatura', label: 'Yer Sahibi Fatura',
      children: <YsFaturaTab api={api} lokasyon={lokasyon} onLokasyonKaldir={lokasyonKaldir} />,
    },
    { key: 'sozlesmeler', label: 'Sözleşmeler', children: <SozlesmelerTab api={api} /> },
    { key: 'enflasyon', label: 'Enflasyon', children: <EnflasyonTab api={api} /> },
    { key: 'defter', label: 'Defter', children: <DefterTab api={api} /> },
  ];
  const tabParam = searchParams.get('tab');
  const ilkSekme = items.some((i) => i.key === tabParam) ? tabParam : items[0].key;
  return (
    <div className="nf-module">
      <Title level={3} style={{ marginTop: 0 }}>
        <FileTextOutlined style={{ marginRight: 8 }} /> Sözleşme & Fatura
      </Title>
      <Tabs items={items} type="card" destroyInactiveTabPane defaultActiveKey={ilkSekme} />
    </div>
  );
}
